import { render, staticRenderFns } from "./aIResource.vue?vue&type=template&id=491a91a5&scoped=true"
import script from "./aIResource.vue?vue&type=script&lang=js"
export * from "./aIResource.vue?vue&type=script&lang=js"
import style0 from "./aIResource.vue?vue&type=style&index=0&id=491a91a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a91a5",
  null
  
)

export default component.exports